
const translation = {
  // ServerCard.tsx
  ServerCard: {
    gpu_model: 'GPU Model',
    gpu_count: 'GPU Count',
    cpu_count: 'CPU Cores',
    cpu_model: 'CPU Model',
    cpu_arch: 'CPU Arch',
    memory: 'Memory',
    gpu_memory: 'GPU Memory',
    system_disk: 'System Disk',
    data_disk: 'Data Disk',
    cuda_version: 'CUDA Version',
    gpu_flops: 'FLOPS',
    area: 'Available Area',
    buy: 'Buy',
    rentable: '{{count}} card(s) available',
    available_more: 'adequate resources',
    available_few: 'limited resources',
    available_no: 'sold out',
    createContainer: 'Create container instance',
    createTask: 'Create training task',
    createServer: 'Create inference service',
    ENOUGH: 'enough',
    SURGING: 'surging',
    SOLD_OUT: 'sold out',
    pricePerHour: 'Yuan/Hour',
  },

  // Status.tsx
  Status: {
    ready: 'Ready',
    ok: 'OK',
    success: 'Success',
    running: 'Running',
    creating: 'Creating',
    error: 'Error',
    starting: 'Starting',
    stopping: 'Stopping',
    pending: 'Pending',
    queuing: 'Queuing',
    stopped: 'Stopped',
    init: 'Initializing',
    failed: 'Failed',
    warning: 'Warning',
    online: 'Online',
    offline: 'Offline',
    open: 'Open',
    close: 'Close',
    unknown: 'Unknown',
    closing: 'Closing',
    importing: 'Importing',
    published: 'Published',
    scaling: 'Scaling',
  },

  gitImport: {
    failureTitle: 'Git import failed',
    failureHint: 'Check the repository URL, network, and permissions below, then try importing again.',
    viewReason: 'View details',
    logTailLabel: 'Task log (tail)',
  },

  // ResourceSpecForm.tsx
  ResourceSpecForm: {
    name: 'Name',
    gpu_name: 'GPU Model',
    gpu_key: 'GPU Key',
    gpu_num: 'GPU Count',
    gpu_mem: 'GPU Memory',
    cpu_num: 'CPU Cores',
    cpu_name: 'CPU Model',
    cpu_arch: 'CPU Architecture',
    mem_size: 'Memory Size',
    extras: 'Other Resources',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },

  // ResourceQuotaForm.tsx
  ResourceQuotaForm: {
    project: 'Project',
    queue: 'Resource Queue',
    expired_at: 'Expiration Time',
    confirm: 'Confirm',
    cancel: 'Cancel',
    user: 'User',
    userTooltip: 'Select the target user for resource quota allocation',
  },

  // ResourceGroupForm.tsx
  ResourceGroupForm: {
    name: 'Name',
    description: 'Description',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },

  // ImageList.tsx
  ImageList: {
    delete_success: 'Delete succeeded!',
    delete_failed: 'Delete failed!',
    confirm_delete: 'Confirm Delete',
    confirm_delete_content: 'Are you sure to delete this image?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    nameAndId: 'Name / ID',
    tags: 'Tags',
    registry: 'Registry',
    usage: 'Usage',
    status: 'Status',
    permission: 'Permission',
    created_at: 'Created/Updated At',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    operation: 'Operation',
    edit: 'Edit',
    export: 'Export',
    import: 'Import',
    delete: 'Delete',
    export_copied: 'Export command copied to clipboard!',
    import_copied: 'Import command copied to clipboard!',
    create_image: 'Create Image',
  },

  // TrainingTaskForm.tsx
  TrainingTaskForm: {
    name: 'Name',
    permission: 'Permission',
    description: 'Description',
    resource: 'Training Resource',
    framework: 'Training Framework',
    environment: 'Training Environment',
    base_model: 'Base Model',
    model_version: 'Model Version',
    training_data: 'Training Data',
    dataset_version: 'Dataset Version',
    volume_mounts: 'Volume Mounts',
    working_dir: 'Working Directory',
    cmd: 'Start Command',
    args: 'Start Arguments',
    env: 'Environment Variables',
    restart_policy: 'Restart Policy',
    restart_count: 'Restart Count',
    output_model: 'Output Model',
    output_model_name: 'Output Model Name',
    model_path: 'Model Path',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save_template: 'Save as Template',
    template_name: 'Template Name',
    template_name_required: 'Template name cannot be empty',
  },

  // DeploymentForm.tsx
  DeploymentForm: {
    service_name: 'Service Name',
    service_type: 'Service Type',
    deployment_permission: 'Deployment Permission',
    deployment_resource: 'Deployment Resource',
    storage_mount: 'Storage Mount',
    deployment_model: 'Deployment Model',
    deployment_model_version: 'Deployment Model Version',
    inference_image: 'Inference Image',
    working_dir: 'Working Directory',
    cmd: 'Start Command',
    args: 'Start Arguments',
    env: 'Environment Variables',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },

  // DeploymentList.tsx
  DeploymentList: {
    id_name: 'Name / ID',
    status: 'Status',
    permission: 'Permission',
    model: 'Model',
    image: 'Image',
    resource_info: 'Resource Info',
    replicas: 'Replicas',
    created_at: 'Created/Updated At',
    access_entry: 'Access Entry',
    access_service: 'Access Service',
    set_model: 'Set Model',
  },

  // InstanceForm.tsx
  InstanceForm: {
    instance_name: 'Instance Name',
    resource_selection: 'Resource Selection',
    volume_mounts: 'Volume Mounts',
    container_image: 'Container Image',
    working_dir: 'Working Directory',
    cmd: 'Start Command',
    args: 'Start Arguments',
    env: 'Environment Variables',
    port_mapping: 'Port Mapping',
    confirm: 'Confirm',
    cancel: 'Cancel',
    updateInstance: 'Update Instance',
    createInstance: 'Create Instance',
  },

  // GitRepoModal.tsx
  GitRepoModal: {
    modal: 'Modal',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },

  // Money.tsx
  Money: {
    cny: 'CNY',
    usd: 'USD',
  },

  // ImageUsage.tsx
  ImageUsage: {
    ecs: 'ECS',
    train: 'Training',
    deploy: 'Deployment',
    all: 'General',
  },

  // DeploymentScaleBtn.tsx
  DeploymentScaleBtn: {
    scale_capacity: 'Scale Capacity',
    scale_success: 'Scale capacity succeeded!',
    scale_failed: 'Scale capacity failed!',
    scale_title: 'Scale Capacity',
    replicas_count: 'Inference service replicas:',
  },

  // BillingMode.tsx
  BillingMode: {
    payg: 'Pay-as-you-go',
  },

  // ResourceSelectorDesc.tsx
  ResourceSelectorDesc: {
    unknown: 'Unknown',
    view: 'View',
    dash: '--',
  },

  // ChangeImageBtn.tsx
  ChangeImageBtn: {
    change_image: 'Change Image',
    image: 'Image',
    confirm: 'Confirm',
    success: 'Image changed successfully!',
    failed: 'Failed to change image!',
  },

  // RechargeBtn.tsx
  RechargeBtn: {
    recharge_now: 'Recharge Now',
    account_recharge: 'Account Recharge',
  },
  // DataUsagePie.tsx
  dataUsagePie: {
    used: 'Used',
  },
  // UserSelect.tsx
  userSelect: {
    placeholder: 'Select User',
  },
  // ServerForm.tsx
  serverForm: {
    userTenantId: 'User Tenant ID',
  },

  // SaveImageBtn.tsx
  SaveImageBtn: {
    save_image: 'Save Image',
    create_image: 'Create Image',
    update_image: 'Update Image',
  },

  // ResourceSelector.tsx
  ResourceSelector: {
    billing_mode: 'Billing Mode',
    payg: 'Pay-as-you-go',
    reserved_day: 'Daily Reserved',
    reserved_week: 'Weekly Reserved',
    available_region: 'Available Region',
    resource_cluster: 'Resource Cluster',
    resource_queue: 'Resource Queue',
    resource_spec: 'Resource Specification',
    instance_count: 'Instance Count',
    // Validation error messages
    resource_required: 'Resource cannot be empty',
    billing_mode_required: 'Billing mode cannot be empty',
    region_required: 'Region cannot be empty',
    cluster_required: 'Resource cluster cannot be empty',
    queue_required: 'Resource queue cannot be empty',
    resource_spec_required: 'Resource specification cannot be empty',
    instance_count_required: 'Instance count cannot be empty',
  },

  // Common operations
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    create: 'Create',
    update: 'Update',
    save: 'Save',
    export: 'Export',
    import: 'Import',
    view: 'View',
    unknown: 'Unknown',
    success: 'Success',
    failed: 'Failed',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    deleteFile: 'Delete File',
    deleteFileConfirm: 'Are you sure you want to delete this file?',
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    search: 'Search',
  },

  label: {
    idOrName: 'Name / ID',
    tag: 'Tag',
    status: 'Status',
    permission: 'Permission',
    storageDisk: 'Disk Storage',
    doc: 'Document',
    createdOrUpdatedAt: 'Created/Updated At',
    action: 'Action',
    publicDataset: 'Dataset',
    detail: 'Detail',
    version: 'Version',
    file: 'File',
    directory: 'Directory',
    datasetDetail: 'Dataset Detail',
    createDataset: 'Create Dataset',
    datasetName: 'Dataset Name',
    datasetDescription: 'Dataset Description',
    storageDiskTip: 'Select the storage disk for storing dataset files',
    datasetPath: 'Dataset Path',
    datasetPathTip: 'Relative path of the dataset in the disk or S3 path, e.g. datasets/my-dataset',
    datasetPermission: 'Dataset Permission',
    datasetDoc: 'Dataset Document',
    datasetDocUrlTip: 'Documentation or reference link for the dataset, helping users understand its format and usage',
    createDisk: 'Create Disk',
    diskDetail: 'Detail',
    unknown: 'Unknown',
    alias: 'Alias',
    storageCluster: 'Storage Cluster',
    size: 'Size',
    readOnly: 'Read Only',
    yes: 'Yes',
    no: 'No',
    user: 'User',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    name: 'Name',
    project: 'Project',
    sizeLimit: 'Disk Size Limit',
    path: 'Path',
    pathTip:
      'Storage path of the disk, if not filled, the system will generate it automatically',
    readOnlyTip: 'Read only for others',
    readOnlyCheckbox: 'Read only for others',
    selectDisk: 'Select Disk',
    用户磁盘: 'User Disk',
    公共模型: 'Public Model',
    diskFiles: 'Files',
    pageInfo: 'Page {{current}} / {{total}}',
  },
  action: {
    uploadSuccess: 'Upload succeeded',
    uploadFail: 'Upload failed',
    uploadFile: 'Upload File',
    edit: 'Edit',
    publish: 'Publish',
    import: 'Import',
    delete: 'Delete',
    createDataset: 'Create Dataset',
    viewDoc: 'View Document',
    editDataset: 'Edit Dataset',
    deleteDisk: 'Delete Disk',
    updateDisk: 'Update Disk',
    createDisk: 'Create Disk',
    download: 'Download',
    preview: 'Preview',
    confirm: 'Confirm',
    cancel: 'Cancel',
    prevPage: 'Previous Page',
    nextPage: 'Next Page',
  },
  StorageList: {
    fileName: 'File Name',
    extension: 'Extension',
    size: 'Size',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    operation: 'Operation',
    uploadFile: 'Upload File',
    download: 'Download',
    delete: 'Delete',
  },
  placeholder: {
    search: 'Search',
    relativePath: 'Relative path on disk',
    selectVersion: 'Select Version',
  },
  msg: {
    importSuccess: 'Import task submitted',
    importError: 'Import failed',
    selectStorageDisk: 'Please select storage disk',
    inputDatasetPermission: 'Please enter dataset permission',
    inputDatasetDocUrl: 'Please enter dataset document URL',
    confirmDeleteFile: 'Confirm Delete File',
    cannotUndo: 'This action cannot be undone',
    previewNotSupported: 'Currently only image, PDF and CSV files are supported for preview',
    previewFail: 'Failed to preview file',
    pdfLoadFail: 'Failed to load PDF',
    csvLoadFail: 'Failed to load CSV file',
    csvEmpty: 'CSV file is empty',
    csvTotalRows: 'Total {{total}} rows',
  },
  modelForm: {
    label: {
      name: 'Model Name',
      description: 'Model Description',
      disk: 'Storage Disk',
      path: 'Model Path',
      permission: 'Model Permission',
      docUrl: 'Model Document',
    },
    tooltip: {
      name: 'Unique name for the model, used to identify and reference it in the system',
      description: 'Brief description of the model purpose and characteristics for easier discovery and management',
      path: 'Relative path of the model in the disk, e.g. models/my-model-v1',
      permission: 'Set model access permission: private is visible only to you, public is visible to all project members',
      docUrl: 'Documentation or reference link for the model, helping other users understand its usage',
    },
    msg: {
      selectDisk: 'Please select a storage disk',
      inputPermission: 'Please enter model permission',
      inputDocUrl: 'Please enter model document URL',
    },
    placeholder: {
      path: 'Relative path of the model in the disk',
    },
    action: {
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    args: {
      nameRequired: 'Argument name is required',
      namePlaceholder: 'Argument Name',
      descPlaceholder: 'Argument Description',
      valuePlaceholder: 'Argument Value',
    }
  },
  modelList: {
    label: {
      idName: 'Name / ID',
      tags: 'Tags',
      status: 'Status',
      permission: 'Permission',
      disk: 'Storage Disk',
      trainDetail: 'Training Detail',
      doc: 'Document',
      createUpdateTime: 'Created/Updated Time',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      action: 'Action',
    },
    action: {
      view: 'View',
      edit: 'Edit',
      publish: 'Publish',
      import: 'Import',
      delete: 'Delete',
      create: 'Create Model',
    },
    import: {
      title: 'Import Model',
      placeholder: 'Please enter Git repository URL',
      msg: {
        inputGitUrl: 'Please enter Git repository URL',
      },
      success: 'Import successful',
    },
  },
  modelSelector: {
    placeholder: {
      selectModel: 'Select Model',
    },
  },
  modelVersionList: {
    label: {
      name: 'Name',
      created: 'Created Time',
      action: 'Action',
    },
    action: {
      delete: 'Delete',
    },
  },
  modelVersionSelector: {
    placeholder: {
      selectVersion: 'Select Version',
    },
  },
  repository: {
    title: 'Image Repository',
    detailTitle: 'Repository Detail',
    createTitle: 'Create Repository',
    create: 'Create Image Repository',
    nameAndId: 'Name / ID',
    permission: 'Permission',
    registry: 'Registry',
    namespace: 'Namespace',
    username: 'Username',
    password: 'Password',
    quota: 'Quota',
    hosted: 'Platform assigned image repository (pay-as-you-go), quota:',
    harbor_url: 'Harbor URL',
    created_at: 'Created At',
    operation: 'Operation',
    delete: 'Delete',
    confirmDelete: 'Are you sure to delete this repository?',
    searchPlaceholder: 'Search',
    description: 'Description',
    confirm: 'Confirm',
    cancel: 'Cancel',
    view: 'View',
    edit: 'Edit',
    editTitle: 'Edit Image Repository',
  },
  image: {
    title: 'Image',
    createTitle: 'Create Image',
    detailTitle: 'Image Detail',
    editTitle: 'Edit',
    saveTitle: 'Save',
    id: 'ID',
    tags: 'Tags',
    registry: 'Registry',
    usage: 'Usage',
    size: 'Size',
    created_at: 'Created At',
    operation: 'Operation',
    delete: 'Delete',
    confirmDelete: 'Are you sure to delete this image?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    view: 'View',
    name: 'Image Name',
    tag: 'Image Tag',
    description: 'Description',
    working_dir: 'Working Directory',
    cmd: 'Start Command',
    args: 'Start Arguments',
    dockerfile: 'Dockerfile',
    permission: 'Permission',
    is_third: 'Third-party Public Image',
    image_url: 'Image URL',
    repository: 'Repository',
    success: 'Operation succeeded',
    failed: 'Operation failed',
    usageEcs: 'ECS',
    usageTrain: 'Train',
    usageDeploy: 'Deploy',
    usageAll: 'General',
    build_image: 'Build Image',
    placeholder: 'Select Image',
  },
  resource_spec_table: {
    name: 'Name',
    gpu_name: 'GPU Model',
    gpu_num: 'GPU Count',
    gpu_mem: 'GPU Memory',
    cpu_num: 'CPU Cores',
    cpu_name: 'CPU Model',
    mem_size: 'Memory Size',
    disk_size: 'Disk Size',
    disk_type: 'Disk Type',
    available: 'Available',
    postPaidPrice: 'Current Price / Original Price (Per Hour)'
  },
  server_spec: {
    create: 'Create Server Spec',
    edit: 'Edit',
    delete: 'Delete',
    delete_action: 'Delete Server Spec',
    disk_size: 'Disk Size',
    disk_type: 'Disk Type',
    created_at: 'Created At',
    updated_at: 'Updated At',
    operation: 'Operation',
  },
  // DiskList.tsx
  diskList: {
    label: {
      nameAndId: 'Name / ID',
      alias: 'Alias',
      permission: 'Permission',
      storageCluster: 'Storage Cluster',
      size: 'Size',
      readOnly: 'Read Only',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      action: 'Action',
    },
    action: {
      createDisk: 'Create Disk',
      deleteDiskWithName: 'Delete Disk: {{name}}',
    },
    placeholder: {
      search: 'Search Disk Name',
    },
  },
  // ClusterWorkloadList.tsx
  clusterWorkloadList: {
    columns: {
      id: 'ID',
      queueName: 'Queue Name',
      resourceSpecName: 'Resource Spec Name',
      userName: 'User Name',
      project: 'Project',
      status: 'Status',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
    },
    filters: {
      resourceType: {
        label: 'Resource Type',
        all: 'All',
        shared: 'Shared Resource',
        exclusive: 'Exclusive Resource',
      },
      type: {
        label: 'Type',
        ecs: 'ECS',
        train: 'Training',
        deployment: 'Inference',
      },
      status: {
        label: 'Status',
        all: 'All',
        running: 'Running',
        stopped: 'Stopped',
        init: 'Initializing',
        failed: 'Failed',
        success: 'Success',
      },
      search: 'Search',
    },
  },
  // DeploymentHpaEditor.tsx
  DeploymentHpaEditor: {
    targetUtilizationRequired: 'Please enter target utilization',
    minReplicasRequired: 'Please enter minimum replicas',
    maxReplicasRequired: 'Please enter maximum replicas',
    targetUtilizationRange: 'Please enter target utilization',
    targetMetricRequired: 'Please select target metric',
    minReplicasGreaterThanMax: 'Minimum replicas cannot be greater than maximum replicas',
  },
  // ClusterWorkloadStats.tsx
  ClusterWorkloadStats: {
    projectId: 'Project ID',
    project: 'Project',
    cpu: 'CPU',
    memory: 'Memory',
    operation: 'Operation',
  },
  // ClusterForm.tsx
  ClusterForm: {
    ingressPort: 'Ingress Port',
    ingressPortTooltip: 'External-facing ingress port number of the cluster for accessing cluster services',
  },
  // DatasetList.tsx
  DatasetList: {
    gitRepoPlaceholder: 'Please enter Git repository URL',
    gitRepoRequired: 'Please enter Git repository URL',
  },
  // DeploymentPodList.tsx
  DeploymentPodList: {
    name: 'Name',
    status: 'Status',
    node: 'Node',
    ip: 'IP',
    startTime: 'Start Time',
    operation: 'Operation',
  },
  // EnvEditor.tsx
  EnvEditor: {
    nameRequired: 'Variable name cannot be empty',
    namePlaceholder: 'Environment Variable Name',
    descriptionPlaceholder: 'Environment Variable Description',
    valuePlaceholder: 'Environment Variable Value',
  },
  // ImageForm.tsx
  ImageForm: {
    env: 'Environment Variables',
    envTooltip: 'Set default environment variables for the image, automatically loaded when the container starts',
  },
  // InspectionList.tsx
  InspectionList: {
    ingressFails: 'Domain Access',
    serviceFails: 'Service Access',
    podFails: 'Workload',
    abnormal: 'Abnormal',
    normal: 'Normal',
    inspection: 'Inspection',
    createInspection: 'Create Inspection',
    id: 'ID',
    status: 'Status',
    inspectionInfo: 'Inspection Info',
    dashboard: 'Dashboard',
    startTime: 'Start Time',
    endTime: 'End Time',
    view: 'View',
  },
  // InstancePortsEditor.tsx
  InstancePortsEditor: {
    editPorts: 'Edit Ports',
    updatePortsSuccess: 'Ports updated successfully!',
    updatePortsFailed: 'Failed to update ports!',
  },
  // LabelEditor.tsx
  LabelEditor: {
    nameRequired: 'Label name cannot be empty',
    namePlaceholder: 'Label Name',
    valuePlaceholder: 'Label Value',
  },
  // PortsEditor.tsx
  PortsEditor: {
    nameRequired: 'Port name cannot be empty',
    nameInvalid: 'Port name can only contain lowercase letters, numbers, and hyphens',
    nameDuplicate: 'Port name cannot be duplicated',
    portRange: 'Port number must be between 1-65535',
    targetPortRange: 'Target port number must be between 1-65535',
    namePlaceholder: 'Port Name',
    portPlaceholder: 'Port Number',
    targetPortPlaceholder: 'Target Port Number',
  },
  // LogViewer.tsx
  LogViewer: {
    log: 'Log',
    loginContainer: 'Login Container',
    refreshLog: 'Refresh Log',
    scrollToBottom: 'Scroll to Bottom',
    noLog: 'No log',
  },
  // ModelForm.tsx
  ModelForm: {
    editModel: 'Edit Model',
    createModel: 'Create Model',
  },
  // QueueForm.tsx
  QueueForm: {
    reclaimStrategy: 'Active Resource Reclaim Strategy',
    reclaimStrategyTooltip: 'Actively reclaim low-utilization resources. When resource utilization is below threshold x% for y minutes, actively stop workloads to reclaim resources',
    thresholdRequired: 'Please enter threshold',
    threshold: 'Threshold',
    durationRequired: 'Please enter duration (minutes)',
    duration: 'Duration',
    minutes: 'Minutes',
    enabledRequired: 'Please select whether to enable',
    enabledPlaceholder: 'Please select whether to enable',
  },
  // QueueResourceEditor.tsx
  QueueResourceEditor: {
    nameRequired: 'Resource name cannot be empty',
    nameDuplicate: 'Duplicate resource name',
    namePlaceholder: 'Resource Name',
    quantityPlaceholder: 'Resource Quantity',
  },
  // QueueSelector.tsx
  QueueSelector: {
    running: 'Running',
    pending: 'Pending',
    inQueue: 'In Queue',
    all: 'All',
    jobStatus: 'Job Status',
    remainingResources: 'Remaining Resources',
    noAvailableQueue: 'No available resource queue',
  },
  // RechargeForm.tsx
  RechargeForm: {
    rechargeSuccess: 'Recharge successful!',
    rechargeFailed: 'Recharge failed!',
    rechargeAmount: 'Recharge Amount',
    recharge: 'Recharge',
    yuan: 'Yuan',
  },
  // ResourceSpecDisplay.tsx
  ResourceSpecDisplay: {
    gpu: 'GPU',
    cpu: 'CPU',
    cores: 'Cores',
    memory: 'Memory',
  },
  // ServerSpec/Form.tsx
  ServerSpecForm: {
    updateServerSpec: 'Update Compute Node',
    createServerSpec: 'Create Compute Node',
    name: 'Name',
    gpuVendor: 'GPU Vendor',
    gpuName: 'GPU Name',
    gpuNum: 'GPU Count',
    gpuMem: 'GPU Memory',
    gpuSpp: 'GPU SPP',
    gpuDpp: 'GPU DPP',
    maxCuda: 'Max CUDA Version',
    cpuNum: 'CPU Count',
    cpuName: 'CPU Name',
    memSize: 'Memory Size',
    diskSize: 'Disk Size',
    diskType: 'Disk Type',
  },
  // ServerSpec/Selector.tsx
  ServerSpecSelector: {
    gpu: 'GPU',
    cpu: 'CPU',
    cores: 'Cores',
    memory: 'Memory',
  },
  // StorageClusterDiskList.tsx
  StorageClusterDiskList: {
    id: 'ID',
    alias: 'Alias',
    permission: 'Permission',
    storageCluster: 'Storage Cluster',
    capacity: 'Capacity',
    used: 'Used',
    readOnly: 'Read Only',
    yes: 'Yes',
    no: 'No',
    user: 'User',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    search: 'Search',
  },
  // StorageClusterForm.tsx
  StorageClusterForm: {
    cephPathTooltip: 'Cluster path in file system, e.g.: /',
    localPathTooltip: 'Local storage path, e.g.: /var/lib/trainkr',
    loongstorePathTooltip: 'Cluster path in file system, e.g.: /',
    defaultPathTooltip: 'Default storage path for user disks and data files',
    mountPath: 'Mount Path',
    clusterPath: 'Cluster Path',
    loongstoreApiConfig: 'LoongStore API Configuration',
    configDescription: 'Configuration Description',
    loongstoreConfigDesc: 'LoongStore requires API connection parameters and mount path configuration. Please ensure all compute nodes have correctly mounted the LoongStore file system.',
    apiServer: 'API Server',
    apiServerTooltip: 'LoongStore API server address, without http:// or https:// prefix',
    apiServerPlaceholder: 'loongstore.example.com',
    usernameResourcePool: 'Username/Resource Pool',
    usernameResourcePoolTooltip: 'LoongStore username, also used as resource pool name',
    usernamePlaceholder: 'admin',
    apiPassword: 'API Password',
    apiPasswordTooltip: 'LoongStore API authentication password',
    apiPasswordPlaceholder: 'Please enter API password',
    apiClientId: 'API Client ID',
    apiClientIdTooltip: 'LoongStore OAuth2 authentication client ID for API authorization',
    apiClientSecret: 'API Client Secret',
    apiClientSecretTooltip: 'LoongStore OAuth2 authentication client secret for API authorization',
    computeNodeMountPath: 'Compute Node Mount Path',
    computeNodeMountPathTooltip: 'Mount path of the LoongStore filesystem on compute nodes, e.g. /datapool',
    computeNodeMountPathPlaceholder: '/datapool',
  },
  // StorageClusterStats.tsx
  StorageClusterStats: {
    projectId: 'Project ID',
    project: 'Project',
    diskCount: 'Disk Count',
    totalCapacity: 'Total Capacity',
    used: 'Used',
    userId: 'User ID',
    userName: 'User Name',
    operation: 'Operation',
    view: 'View',
  },
  // ResourceSelectorItems.tsx
  ResourceSelectorItems: {
    currentPricePerHour: 'Current/Original Price (per hour)',
  },
  // StorageResourceQuotaList.tsx
  StorageResourceQuotaList: {
    quotaType: 'Quota Type',
    storageDisk: 'Storage Disk',
    imageRegistry: 'Image Registry',
    domain: 'Domain',
    project: 'Project',
    user: 'User',
    storageClusterOrRegistry: 'Storage Cluster / Image Registry',
    storageSize: 'Storage Size',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    operation: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    createResourceQuota: 'Create Resource Quota',
    search: 'Search',
  },
  importTaskMonitor: {
    stopImport: 'Stop import',
    stopImportConfirmTitle: 'Stop this import?',
    stopImportConfirmDesc: 'The import Job in the cluster will be terminated and the resource will be marked as failed. You can start a new import later.',
    stopImportOk: 'Stop',
    importStopped: 'Import stopped',
  },
  // VolumeMountsEditor.tsx
  VolumeMountsEditor: {
    mountPathRequired: 'Mount path cannot be empty',
    mountPathInvalid: 'Mount path format is incorrect, must start with "/" and cannot end with "/"',
    mountResourceRequired: 'Mount resource cannot be empty',
    disk: 'Disk',
    dataset: 'Dataset',
    model: 'Model',
  },
}

export default translation 
